export const formatName = (name: { givenName: string; familyName: string }) => {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if (!name) {
		return "";
	}

	return `${name.givenName} ${name.familyName}`.trim();
};

export const reloadPage = () => {
	window.location.reload();
};
